import { LinkBox as ChakraLinkBox, LinkBoxProps } from "@chakra-ui/react";

export const LinkBox = (props: LinkBoxProps) => (
  <ChakraLinkBox cursor="pointer" {...props} />
);
